import InstallationProvider from './InstallationProvider';
import useInstallationSetting from './useInstallationSetting';
export default {
  InstallationProvider: InstallationProvider,
  useInstallationSetting: useInstallationSetting
};